interface IProps {
  numberString: string;
  colorActive: string;
  colorUnActive: string;
}
const DigitalIcon = (props: IProps) => {
  const { numberString, colorActive, colorUnActive } = props;
  if (numberString === ":")
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="4"
        height="12"
        viewBox="0 0 4 12"
        fill="none"
      >
        <rect width="4" height="4" fill={colorActive} />
        <rect y="7.2002" width="4" height="4" fill={colorActive} />
      </svg>
    );

  const config = {
    top: true,
    center: true,
    bottom: true,
    leftAbove: true,
    leftBelow: true,
    rightAbove: true,
    rightBelow: true,
  };

  if (numberString === "0") {
    config.center = false;
  } else if (numberString === "1") {
    config.top = false;
    config.center = false;
    config.bottom = false;
    config.leftAbove = false;
    config.leftBelow = false;
  } else if (numberString === "2") {
    config.leftAbove = false;
    config.rightBelow = false;
  } else if (numberString === "3") {
    config.leftAbove = false;
    config.leftBelow = false;
  } else if (numberString === "4") {
    config.top = false;
    config.bottom = false;
    config.leftBelow = false;
  } else if (numberString === "5") {
    config.rightAbove = false;
    config.leftBelow = false;
  } else if (numberString === "6") {
    config.rightAbove = false;
  } else if (numberString === "7") {
    config.center = false;
    config.leftAbove = false;
    config.leftBelow = false;
    config.bottom = false;
  } else if (numberString === "9") {
    config.leftBelow = false;
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="52"
      viewBox="0 0 28 52"
      fill="none"
    >
      <path
        d="M0.271484 0H28.001L22.8858 4.33337H5.11741L0.271484 0Z"
        fill={config.top ? colorActive : colorUnActive}
      />
      <path
        d="M4.30843 23.833H23.6921L27.4612 25.9997L23.6921 28.1664H4.30843L0.808594 25.9997L4.30843 23.833Z"
        fill={config.center ? colorActive : colorUnActive}
      />
      <path
        d="M0 25.4585L-9.88504e-07 1.08328L4.30749 5.14581L4.30749 22.7501L0 25.4585Z"
        fill={config.leftAbove ? colorActive : colorUnActive}
      />
      <path
        d="M27.998 1.35449L27.998 25.4589L23.6906 22.7505L23.6906 5.14619L27.998 1.35449Z"
        fill={config.rightAbove ? colorActive : colorUnActive}
      />
      <path
        d="M26.9238 52L1.07887 52L5.11715 47.6666L22.8856 47.6666L26.9238 52Z"
        fill={config.bottom ? colorActive : colorUnActive}
      />
      <path
        d="M27.998 26.8125L27.998 51.4586L23.6906 47.1252L23.6906 29.25L27.998 26.8125Z"
        fill={config.rightBelow ? colorActive : colorUnActive}
      />
      <path
        d="M0 51.4585L3.24794e-06 26.5416L4.3075 29.25L4.30749 46.8543L0 51.4585Z"
        fill={config.leftBelow ? colorActive : colorUnActive}
      />
    </svg>
  );
};
export default DigitalIcon;
